import type { ClosableLocation } from './location-closure';

import { locationTitleWithClosedMark } from './location-closure';

/** Варианты фильтра «Локация»: id и название с отметкой закрытой локации. */
export function locationFilterOptions(
  locations: readonly (ClosableLocation & { id: string })[],
): { value: string; label: string }[] {
  return locations.map((location) => ({ value: location.id, label: locationTitleWithClosedMark(location) }));
}
